import axios, { AxiosResponse } from 'axios'
import {
  GrupoDto,
  GrupoDtoCreate,
  GrupoDtoUpdate,
  PerfilDtoGrupoUpdate,
  GrupoView,
  GruposQueryResponse,
  PerfilList,
  PerfisQueryResponse,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const GRUPOS_URL = `${API_URL}/grupos`
const PERFIS_URL = `${API_URL}/perfis`

/**
 * Busca todos os grupos (perfis de usuário)
 * @returns GruposQueryResponse
 */
export const getGrupos = (): Promise<GruposQueryResponse> => {
  return axios.get(GRUPOS_URL).then((resp: AxiosResponse<GruposQueryResponse>) => resp.data)
}

/**
 * Busca um grupo
 * @param grupoId Identificador do grupo
 * @returns GrupoView
 */
export const getGrupoById = (grupoId: number): Promise<GrupoView> => {
  return axios.get(`${GRUPOS_URL}/${grupoId}`).then((resp: AxiosResponse<GrupoView>) => resp.data)
}

/**
 * Cadastra um grupo
 * @param data GrupoDtoCreate
 * @returns GrupoDto
 */
export const createGrupo = (data: GrupoDtoCreate): Promise<GrupoDto> => {
  return axios.post(GRUPOS_URL, data).then((resp: AxiosResponse<GrupoDto>) => resp.data)
}

/**
 * Altera o cadastro de um grupo
 * @param grupoId Identificador do grupo
 * @param data GrupoDtoUpdate
 * @returns GrupoDto
 */
export const updateGrupo = (grupoId: number, data: GrupoDtoUpdate): Promise<GrupoDto> => {
  return axios
    .put(`${GRUPOS_URL}/${grupoId}`, data)
    .then((resp: AxiosResponse<GrupoDto>) => resp.data)
}

/**
 * Remove o cadastro de um grupo
 * @param grupoId Identificador do grupo
 * @returns void
 */
export const deleteGrupo = (grupoId: number): Promise<void> => {
  return axios.delete(`${GRUPOS_URL}/${grupoId}`)
}

/**
 * Busca os perfis (permissões) disponíveis para vincular a um grupo
 * @param query string
 * @returns PerfisQueryResponse
 */
export const getPerfis = (query: string): Promise<PerfisQueryResponse> => {
  return axios
    .get(`${PERFIS_URL}?${query}`)
    .then((resp: AxiosResponse<PerfisQueryResponse>) => resp.data)
}

/**
 * Busca um perfil (permissão)
 * @param perfilId Identificador do perfil
 * @returns PerfilList
 */
export const getPerfilById = (perfilId: number): Promise<PerfilList> => {
  return axios.get(`${PERFIS_URL}/${perfilId}`).then((resp: AxiosResponse<PerfilList>) => resp.data)
}

/**
 * Adiciona perfis a um grupo
 * @param grupoId Identificador do grupo
 * @param data PerfilDtoGrupoUpdate
 * @returns GrupoView
 */
export const addPerfisToGrupo = (
  grupoId: number,
  data: PerfilDtoGrupoUpdate
): Promise<GrupoView> => {
  return axios
    .put(`${GRUPOS_URL}/${grupoId}/perfis`, data)
    .then((resp: AxiosResponse<GrupoView>) => resp.data)
}

/**
 * Remove perfis de um grupo
 * @param grupoId Identificador do grupo
 * @param data PerfilDtoGrupoUpdate
 * @returns GrupoView
 */
export const removePerfisFromGrupo = (
  grupoId: number,
  data: PerfilDtoGrupoUpdate
): Promise<GrupoView> => {
  return axios
    .delete(`${GRUPOS_URL}/${grupoId}/perfis`, { data })
    .then((resp: AxiosResponse<GrupoView>) => resp.data)
}
